import { defineComponent as P, useModel as F, computed as i, ref as R, openBlock as v, createElementBlock as b, createVNode as d, unref as u, mergeProps as $, Fragment as D, withModifiers as p, createCommentVNode as E, mergeModels as h } from "vue";
import { RevButtonIcon as x } from "@ds/components/ButtonIcon";
import { RevInputText as O } from "@ds/components/InputText";
import j from "../../icons/generated/IconMinus.vue2.js";
import U from "../../icons/generated/IconPlus.vue2.js";
import { isNumber as y } from "../../utils/isNumber.js";
import { tw as B } from "../../utils/tailwind.js";
const z = { class: "relative" }, Y = /* @__PURE__ */ P({
  name: "RevInputNumber",
  inheritAttrs: !1,
  __name: "InputNumber",
  props: /* @__PURE__ */ h({
    autofocus: { type: Boolean, default: !1 },
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: B`mt-8` },
    id: {},
    label: {},
    max: { default: void 0 },
    min: { default: void 0 },
    minusAriaLabel: { default: "-" },
    modelValue: {},
    plusAriaLabel: { default: "+" },
    showStepper: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    step: { default: 1 },
    precision: { default: void 0 },
    required: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ h(["input", "invalid", "valid"], ["update:modelValue"]),
  setup(t, { emit: g }) {
    const a = t, r = g, n = F(t, "modelValue"), s = i({
      get: () => n.value != null ? String(n.value) : n.value,
      set: (e) => {
        if (e == null || e === "") {
          n.value = void 0;
          return;
        }
        r("valid"), n.value = Number(e);
      }
    }), o = i(() => y(a.step) ? a.step : 1), C = i(() => {
      if (a.precision !== void 0) return a.precision;
      const e = String(o.value), l = e.indexOf(".");
      return l === -1 ? 0 : e.length - l - 1;
    }), m = R(), V = i(
      () => !a.showStepper && a.showClearButton
    ), w = i(() => a.disabled ? !0 : a.min === void 0 ? !1 : Number(s.value) - o.value < a.min), N = i(() => a.disabled ? !0 : a.max === void 0 ? !1 : Number(s.value) + o.value > a.max), c = () => {
      m.value?.input.focus();
    }, k = (e) => r("input", e), A = () => r("valid"), I = (e, l) => r("invalid", e, l), M = () => {
      n.value = void 0, c();
    }, f = (e) => {
      const l = y(n.value) ? Number(n.value) : 0;
      n.value = parseFloat(e(l).toFixed(C.value)), c();
    }, S = () => {
      f((e) => e - o.value);
    }, L = () => {
      f((e) => e + o.value);
    }, T = i(
      () => a.showStepper && B`pr-[92px] [&+label]:pr-80`
    );
    return (e, l) => (v(), b("div", z, [
      d(u(O), $({
        id: t.id,
        ref_key: "inputText",
        ref: m
      }, e.$attrs, {
        modelValue: s.value,
        "onUpdate:modelValue": l[0] || (l[0] = (q) => s.value = q),
        autofocus: t.autofocus,
        "clear-button-aria-label": t.clearButtonAriaLabel,
        description: t.description,
        disabled: t.disabled,
        error: t.error,
        "has-clear-button": V.value,
        "helper-text-class": t.helperTextClass,
        "input-class": T.value,
        label: t.label,
        max: t.max,
        min: t.min,
        required: t.required,
        step: "any",
        type: "number",
        onClear: M,
        onInput: k,
        onInvalid: I,
        onValid: A
      }), null, 16, ["id", "modelValue", "autofocus", "clear-button-aria-label", "description", "disabled", "error", "has-clear-button", "helper-text-class", "input-class", "label", "max", "min", "required"]),
      t.showStepper ? (v(), b(D, { key: 0 }, [
        d(u(x), {
          "aria-label": t.minusAriaLabel,
          class: "absolute inset-y-4 right-44",
          "data-test": "minus-button",
          disabled: w.value,
          icon: u(j),
          type: "button",
          variant: "ghost",
          onClick: S,
          onMousedown: l[1] || (l[1] = p(() => {
          }, ["prevent"]))
        }, null, 8, ["aria-label", "disabled", "icon"]),
        d(u(x), {
          "aria-label": t.plusAriaLabel,
          class: "absolute inset-y-4 right-4",
          "data-test": "plus-button",
          disabled: N.value,
          icon: u(U),
          type: "button",
          variant: "ghost",
          onClick: L,
          onMousedown: l[2] || (l[2] = p(() => {
          }, ["prevent"]))
        }, null, 8, ["aria-label", "disabled", "icon"])
      ], 64)) : E("", !0)
    ]));
  }
});
export {
  Y as default
};
